// extracted by mini-css-extract-plugin
module.exports = {"PlayerWrapper":"ResponsivePlayer_PlayerWrapper__1RtJ9","ReactPlayer":"ResponsivePlayer_ReactPlayer__2WTpX"};